import { render, staticRenderFns } from "./SubscriptionPage.vue?vue&type=template&id=25ae3a0a&scoped=true&"
import script from "./SubscriptionPage.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPage.vue?vue&type=style&index=0&id=25ae3a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae3a0a",
  null
  
)

export default component.exports